import styled from '../../utils/styled';
import { spacing } from '../../utils';
import { Box } from '../../primitives/Box';
import { StackProps } from './types';

export const Stack = styled(Box)<StackProps>`
    display: flex;
    flex-direction: ${({ orientation }): string => {
        switch (orientation) {
            case 'vertical':
                return 'column';
            case 'horizontal-reverse':
                return 'row-reverse';
            case 'vertical-reverse':
                return 'column-reverse';
            default:
                return 'row';
        }
    }};
    margin: 0;

    > *:not(:last-child) {
        margin-right: ${({ gutter = 'md', orientation }) => orientation === 'horizontal' && spacing(gutter)};
        margin-bottom: ${({ gutter = 'md', orientation }) => orientation === 'vertical' && spacing(gutter)};
        margin-left: ${({ gutter = 'md', orientation }) => orientation === 'horizontal-reverse' && spacing(gutter)};
        margin-top: ${({ gutter = 'md', orientation }) => orientation === 'vertical-reverse' && spacing(gutter)};
    }
`;
